import { HTTP } from '../http'

export const TRACKER_API = {
  createTemplate: async (url, data, modality, sessionId) => {
    return HTTP.put(
      url + modality.getTemplateEndpoint(),
      data,
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  deleteTemplate: async (url, data, modality, sessionId) => {
    return HTTP.delete(
      url + modality.getTemplateEndpoint(),
      { data, headers: { 'X-Session-ID': sessionId } }
    )
  },
  getProfile: async (url, sessionId, modality) => {
    return HTTP.get(
      url + modality.name + '/profile',
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  stopTransaction: async (url, transactionId, modality, sessionId) => {
    return HTTP.delete(
      url + modality.getTransactionEndpoint(),
      {
        headers: {
          'X-Session-ID': sessionId,
          'X-Transaction-Id': transactionId
        }
      }
    )
  },
  createTransaction: async (url, modality, sessionId) => {
    return HTTP.post(
      url + modality.getTransactionEndpoint(),
      {},
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  getTransactionStatus: async (url, transactionId, modality, sessionId) => {
    return HTTP.get(
      url + modality.getTransactionEndpoint(),
      {
        headers: {
          'X-Session-ID': sessionId,
          'X-Transaction-Id': transactionId
        }
      }
    )
  },
  startTransaction: async (url, data, transactionId, modality, sessionId) => {
    return HTTP.put(
      url + modality.getTransactionEndpoint(),
      data,
      {
        headers: {
          'X-Session-ID': sessionId,
          'X-Transaction-Id': transactionId
        }
      }
    )
  },
  addCandidatePersonsToTransaction: async (url, data, transactionId, modality, sessionId) => {
    return HTTP.post(
      url + modality.getTransactionEndpoint() + '/candidate/person',
      data,
      {
        headers: {
          'X-Session-ID': sessionId,
          'X-Transaction-Id': transactionId
        }
      }
    )
  },
  addCandidateGroupsToTransaction: async (url, data, transactionId, modality, sessionId) => {
    return HTTP.post(
      url + modality.getTransactionEndpoint() + '/candidate/group',
      data,
      {
        headers: {
          'X-Session-ID': sessionId,
          'X-Transaction-Id': transactionId
        }
      }
    )
  },
  addReferenceGroupsToTransaction: async (url, data, transactionId, modality, sessionId) => {
    return HTTP.post(
      url + modality.getTransactionEndpoint() + '/reference/group',
      data,
      {
        headers: {
          'X-Session-ID': sessionId,
          'X-Transaction-Id': transactionId
        }
      }
    )
  },
  addReferencePersonsToTransaction: async (url, data, transactionId, modality, sessionId) => {
    return HTTP.post(
      url + modality.getTransactionEndpoint() + '/reference/person',
      data,
      {
        headers: {
          'X-Session-ID': sessionId,
          'X-Transaction-Id': transactionId
        }
      }
    )
  },
  deletePersons: async (url, data, sessionId) => {
    return HTTP.delete(
      url + 'person/persons',
      { data, headers: { 'X-Session-ID': sessionId } }
    )
  },
  getFacesBorders: async (url, body, sessionId) => {
    return HTTP.post(
      url + 'face/border',
      body,
      { headers: { 'X-Session-ID': sessionId } }
    )
  }
}
